import { Typography } from '@smartgift/frontend-toolkit';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Notification } from '@hero/atoms';
import { useRecogCalculateEstimatedCharge } from '@hero/services';

import { ProductSelectionSection } from '../Product';

import { FLOW_STEPS } from './constant';
import * as S from './style';

function ProductList({
  setModalObject,
  onRequestClose,
  contactCount,
  isLiveFeature,
  updateProducts,
  setNewEstimatedCharge,
  selectedProducts,
  setSelectedProducts,
  initialSelectedProducts,
  setCurrentFlow,
  featureType,
  isDraft
}) {
  const { recognitionCode } = useParams();
  const { t } = useTranslation();
  const { mutateAsync: calculateRecognitionCharge, isLoading: isLoadingCalculation } =
    useRecogCalculateEstimatedCharge();

  const onSaveChanges = async () => {
    if (isLiveFeature && recognitionCode) {
      const calculated = await calculateRecognitionCharge({
        params: {
          code: recognitionCode
        },
        body: {
          products: selectedProducts,
          recipientCount: contactCount
        }
      });

      if (calculated?.difference?.total > 0) {
        setNewEstimatedCharge(calculated);
        setCurrentFlow(FLOW_STEPS.reviewAndSubmit);
        return;
      }
    }

    await updateProducts(selectedProducts);
    onRequestClose();
  };

  useEffect(() => {
    setModalObject({
      title: t('editGiftCollection'),
      primaryButtonProps: {
        children: t('saveChanges'),
        onClick: onSaveChanges,
        disabled:
          !selectedProducts?.length ||
          isEqual(selectedProducts, initialSelectedProducts) ||
          isLoadingCalculation,
        loading: isLoadingCalculation
      },
      secondaryButtonProps: {
        children: t('cancel'),
        onClick: onRequestClose
      }
    });
  }, [selectedProducts, isLoadingCalculation]);

  return (
    <S.Content>
      {selectedProducts?.length === 0 && (
        <Notification
          status="warning"
          message={<Typography variant="body2">{t('youMusIncludeOneGiftWarning')}</Typography>}
        />
      )}
      <S.ContentWrapper>
        <Typography variant="body1Bold" style={{ marginBottom: 16 }}>
          {t('editCollectionHeaderInfo')}
        </Typography>
        <ProductSelectionSection
          featureType={featureType}
          selectedProducts={selectedProducts}
          onChangeSelectedProductList={setSelectedProducts}
          isDraft={isDraft}
        />
      </S.ContentWrapper>
    </S.Content>
  );
}

ProductList.propTypes = {
  setModalObject: PropTypes.func,
  onRequestClose: PropTypes.func,
  contactCount: PropTypes.number,
  isLiveFeature: PropTypes.bool,
  updateProducts: PropTypes.func,
  setNewEstimatedCharge: PropTypes.func,
  selectedProducts: PropTypes.array,
  setSelectedProducts: PropTypes.func,
  initialSelectedProducts: PropTypes.array,
  setCurrentFlow: PropTypes.func,
  featureType: PropTypes.string,
  isDraft: PropTypes.bool
};

export { ProductList };
